import * as React from "react";
import { TextArea, useFieldState, useFieldApi } from "informedv4";
import { inputClasses } from "../validation/ValidationClasses";

export const TextAreaWithStaticPrefix = ({ field, ...props }) => {
    const fieldState = useFieldState(field);
    const fieldApi = useFieldApi(field);

    return (
        <>
            <div className="input-group">
                <span className="input-group-addon">{props.staticpart}</span>
                <TextArea
                    name={field}
                    field={field}
                    className={inputClasses(fieldApi.getError() as string)}
                    {...props}
                />
            </div>
            {fieldApi.getError() ? <span className="field-validation-error">{fieldApi.getError() as string}</span> : null}
        </>
    );
}
